const PageContainer = ({children, items, desktopItems, px, isRelative }) => {
    return (
        <div className={`w-full mt-4 px-${px} flex flex-col items-${items} lg:items-${desktopItems} ${isRelative ? 'relative': ''}`}>
            {children}
        </div>
    )
}

export default PageContainer;